<script setup lang="ts">
import HotelPoints from '@components/util/hotel-card/HotelPoints.vue';
import { type HotelCommentView } from '@itinerary/hotel/HotelPackageTypes';

const { item } = defineProps<{
    item: HotelCommentView;
}>();
const content = ref<HTMLDivElement>();

const loading = ref(true);

onMounted(() => {
    loading.value = false;
});

const comment = computed(() => item.comment?.replace(/\r\n|\r/g, '\n'));
const badgeLabel = computed(() => (item.reserved ? 'خریدار' : ''));
</script>

<template>
    <div class="comment-container" :class="{ 'loading-skeleton': loading }">
        <div class="header">
            <mr-typography size="large" weight="700">
                {{ item.customer || '' }}
            </mr-typography>
            <mr-typography
                v-if="badgeLabel"
                class="badge"
                size="x-small"
                weight="500"
            >
                {{ badgeLabel }}
            </mr-typography>

            <HotelPoints
                v-if="item.rating"
                :value="item.rating"
                size="medium"
            />
        </div>
        <div ref="content" class="content">
            {{ comment || '' }}
        </div>
    </div>
</template>

<style lang="scss" scoped>
.comment-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 120px;
    &.loading-skeleton {
        visibility: hidden;
        .content.collapsed {
            max-height: none;
            overflow: auto;
        }
    }
    .header {
        display: flex;
        align-items: center;
        gap: 12px;
        .badge {
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: usePalette($p-blue, $p-200);
            border-radius: 100px;
            padding-inline: 8px;
        }
    }
    .content {
        @include tg-m($color: usePalette($p-cool-gray, $p-800));
        position: relative;
        .expand {
            position: absolute;
            bottom: 0;
            left: 0;
            background-color: white;
        }
    }
    .date {
        @include tg-m($color: usePalette($p-gray, $p-600));
    }
}
</style>
